import { IAppTech, ITemplateAppTech } from 'api/types/_campaign';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { APP_TECH_TEMPLATE_TYPE } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { allAppTech, deleteMultiTemplateAppTech, getAllPartners, getTemplateTitleAppTechs as onGetTemplateAppTechs } from "../../../store/thunks";
import TitleForm from './TitleForm';
import { filterMediaOptions } from 'helpers/format';
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);

const TitleList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        content: withDefault(StringParam, ''),
        apptech_id: withDefault(StringParam, ''),
        type: withDefault(StringParam, `${APP_TECH_TEMPLATE_TYPE.TITLE}`),
        media_id: withDefault(StringParam, ''),

    });

    const [appTechs, setAppTechs] = useState<{ label: string, value: string, name: string }[]>([]);

    const [partners, setPartners] = useState<{ label: string, value: string, name: string }[]>([]);

    const [nameSearch, setNameSearch] = useState<string>(query?.content || "");

    const [appSearch, setAppSearch] = useState<Option | null>(appTechs?.find((item) => String(item?.value) === String(query?.apptech_id)) || null);

    const [mediaSearch, setMediaSearch] = useState<Option | null>(partners?.find((item) => String(item?.value) === String(query?.media_id)) || null);

    const [templateDetail, setTemplateDetail] = useState<ITemplateAppTech | null>(null);


    const [isShowPrompt, setIsShowPrompt] = useState<boolean>(false);
    const [promptShow, setPromptShow] = useState<string>('');

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Campaign;

    const CampaignProperties = createSelector(
        selectLayoutState,
        (state) => ({
            templateAppTechs: state.templateTitleAppTechs,
            isTemplateAppTechSuccess: state.isTemplateTitleAppTechSuccess,
            isTemplateAppTechLoading: state.isTemplateTitleAppTechLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { templateAppTechs, error, isTemplateAppTechLoading } = useSelector(CampaignProperties);

    useEffect(() => {
        dispatch(onGetTemplateAppTechs(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        if (isTemplateAppTechLoading) {
            return;
        }
        const queryNew = {
            ...query,
            content: nameSearch || '',
            apptech_id: appSearch?.value || '',
            media_id: mediaSearch?.value || '',
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            content: '',
            apptech_id: '',
            media_id: '',
            order_by: 'DESC',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setNameSearch((_prev) => '');
        setAppSearch((_prev) => null);
        setMediaSearch((_prev) => null);
    };

    const triggerRefresh = async (type: string = '') => {
        onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
    }
    //End::Update

    const handleSetTemplateDetail = (detail: ITemplateAppTech | null) => {
        setTemplateDetail((_prev) => detail);
    }

    const onCloseClick = () => {
        handleSetTemplateDetail(null);
    }

    // Begin::Delete

    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValuesDefault, setInitialValuesDefault] = useState<IAppTech | null>(null);

    const handleConfirmDelete = (item: IAppTech) => {
        setInitialValuesDefault((_prev) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionDelete = async () => {
        if (!(initialValuesDefault?.id)) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteMultiTemplateAppTech({ ids: [initialValuesDefault?.id] });
            if (response?.code === 200) {
                dispatch(onGetTemplateAppTechs(query));
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValuesDefault((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setInitialValuesDefault((_prev) => null);
        setIsConfirm((_prev) => false);
    }
    // End::Delete

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                width: 60,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '40px' }}>{cell?.value}</div>
                    </>
                ),
            },
            {
                Header: t('App'),
                accessor: "apptech",
                filterable: true,
                sortable: false,
                width: 120,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '100px' }} className="d-flex flex-wrap ">
                            {item?.apptech?.name || ''}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Media'),
                accessor: "partner",
                filterable: true,
                sortable: false,
                width: 150,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '130px' }} className="d-flex flex-wrap gap-2">
                            {cell?.value?.name || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Title'),
                accessor: "content",
                filterable: true,
                sortable: false,
                width: 120,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '100px' }} className="d-flex flex-wrap ">
                            {cell?.value || ''}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Actions'),
                accessor: "__",
                thClass: 'align-middle text-center',
                thWidth: 120,
                sortable: false,
                Cell: (cell: any) => {
                    const item: any = cell?.row?.original;
                    return (
                        <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '90px' }}>
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_UPDATE, userPermissions) && <TooltipCustom
                                title={t('Button Update Template')}
                                id={`update-us-${item?.id}`}
                            >
                                <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
                                    <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
                                        onClick={(e) => { e.preventDefault(); handleSetTemplateDetail(item) }}
                                    >
                                        <i className="ri-pencil-fill align-bottom"></i>
                                    </Link>
                                </li>
                            </TooltipCustom>}
                            {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_DELETE, userPermissions) && (
                                <TooltipCustom
                                    title={t('Button Delete Template')}
                                    id={`detail-cp-${item?.id}`}
                                >
                                    <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
                                        <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
                                            onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
                                        >
                                            <i className="ri-delete-bin-3-fill align-bottom"></i>
                                        </Link>
                                    </li>
                                </TooltipCustom>
                            )}
                        </ul>
                    );
                },
            },
        ],
        [i18n?.language, JSON.stringify(userPermissions)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleCallAllOption = async () => {
        try {
            const [res1, res2]: any = await Promise.all([allAppTech({}), getAllPartners({})]);
            const _list_app_tech = (res1?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name }));
            const _list_partner = (res2?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name, is_partner: ml?.is_partner, partner_codes: ml?.partner_codes, partner_reporters: ml?.partner_reporters }));
            setAppTechs((_prev: any) => _list_app_tech);
            setPartners((_prev: any) => _list_partner);
            if (query?.apptech_id) {
                const _val = (_list_app_tech)?.find((s: any) => String(s?.value) === String(query?.apptech_id));
                setAppSearch(_val);
            }
            if (query?.media_id) {
                const _val = (_list_partner)?.find((s: any) => String(s?.value) === String(query?.media_id));
                setMediaSearch(_val);
            }
        } catch (error: any) {
            return error;
        }
    };

    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_LIST, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-7">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isTemplateAppTechLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={templateAppTechs?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-sm-5 text-end">
                                        {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_APP_TECH_CREATE, userPermissions) && (<div className="col-sm-auto">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-success add-btn rounded-pill"
                                                    id="create-btn"
                                                    onClick={() => {
                                                        handleSetTemplateDetail({ time_request: + new Date() } as any)
                                                    }}
                                                >
                                                    <i className="ri-add-line align-bottom me-1"></i>
                                                    {t('Button Create Template')}
                                                </button>
                                            </div>
                                        </div>)}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('App')} isShow={true}>
                                            <DropdownOption
                                                name="app"
                                                dataList={appTechs || []}
                                                placeholder={`${t("App")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={appSearch || null}
                                                onChangeSelect={(e: any) => setAppSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('Media')} isShow={true}>
                                            <DropdownOption
                                                name="media"
                                                dataList={filterMediaOptions(partners || [])}
                                                placeholder={`${t("Media")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={mediaSearch || null}
                                                onChangeSelect={(e: any) => setMediaSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3 mt-xl-2'>
                                        <LabelWrapper label={t('Title')} isShow={!!nameSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Title')}...`}
                                                value={nameSearch}
                                                onChange={(e) => setNameSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-xl-start mt-3 mt-xl-2">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isTemplateAppTechLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card"
                                    tableClass="align-middle"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={templateAppTechs?.list?.length ? templateAppTechs?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={templateAppTechs?.pagination?.total}
                                    customPageCount={Math.ceil(Number(templateAppTechs?.pagination?.total) / Number(templateAppTechs?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isTemplateAppTechLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <Modal
                isOpen={!!isShowPrompt}
                centered={true}
                size="lg"
                scrollable={true}
                toggle={() => setIsShowPrompt(() => false)}
            >
                <ModalHeader toggle={() => setIsShowPrompt(() => false)}>
                    <>{t("Prompt")}</>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="fs-15" style={{ whiteSpace: 'break-spaces' }}>
                        {promptShow || ''}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => setIsShowPrompt(() => false)}
                            style={{ width: '100px' }}
                        >
                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

            <TitleForm
                isOpen={!!templateDetail}
                detail={templateDetail}
                appTechs={appTechs}
                partners={partners}
                onClose={onCloseClick}
                triggerRefresh={triggerRefresh}
            />

            <ModalConfirm
                header={t('Button Delete Template')}
                isOpen={isOpenConfirm}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionDelete}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default TitleList;